export default __webpack_public_path__ + "static/media/garden-plant.edc92bc7.svg";